import { defineStore } from 'pinia'
import { useGinnelsStore } from '@/stores/ginnels/ginnels'
import { useFilesStore } from '@/stores/ginnels/files'
import { useCollectionsStore } from '@/stores/collections/collections'
import { useUserTagsStore } from '@/stores/user/tags'
import axios from 'axios'

export const useResetStore = defineStore({
	id: 'app',
	state: () => ({
    stores: [
      useGinnelsStore(),
      useCollectionsStore(),
      useFilesStore(),
      useUserTagsStore(),
    ],
	}),
	actions: {
		/**
			* resetStores
			* Clears all stores of data
		*/
		resetStores() {
      this.stores.forEach(store => store.$reset())
		},
	}
})